export default __webpack_public_path__ + "static/3-4f5a0c5fc8f00c388e3aa522f5fc570a.png";